import { upperFirst } from "lodash";
import { DateTime } from "luxon";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";

import { ClientContext } from "../App";
import { getPolicies } from "../lib/automatic";
import seedData from "../seed/policies.json";
import LoadingSpinner from "./LoadingSpinner";
import Table from "./table/Table";

const PoliciesTable = () => {
  const { promiseInProgress } = usePromiseTracker();
  const [policies, setPolicies] = useState([]);

  const { selectedClient: clientId } = useContext(ClientContext);
  const columns = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "user.firstName",
        Cell: ({ value }) => {
          return value ? upperFirst(value) : "—";
        },
        width: 100,
      },

      {
        Header: "Last Name",
        accessor: "user.lastName", // accessor is the "key" in the data
        Cell: ({ value }) => {
          return value ? upperFirst(value) : "—";
        },
        width: 100,
      },

      {
        Header: "User ID",
        accessor: "user.id", // accessor is the "key" in the data
        width: 250,
      },

      {
        Header: "Policy ID",
        accessor: "id",
        width: 250,
      },

      {
        Header: "Last Updated",
        id: "lastUpdated",
        accessor: (row) => row.modifiedAt || row.createdAt,
        disableFilters: true,
        Cell: ({ value }) => {
          return value
            ? DateTime.fromISO(value).toLocaleString({
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })
            : "—";
        },
        width: 100,
      },
    ],
    []
  );

  useEffect(() => {
    // Use seed data if set to true
    if (process.env.REACT_APP_MOCK === "true") {
      setPolicies(seedData);
      return;
    }

    // Retrieve ignition sessions and set to state
    trackPromise(
      getPolicies(clientId).then((data) => {
        setPolicies(data);
      })
    );
  }, []);

  return (
    <>
      {promiseInProgress === true ? (
        <LoadingSpinner />
      ) : (
        <>
          <Table
            data={policies}
            columns={columns}
            rowBehavior={{
              type: "link",
              config: { path: "/policies", resourceKey: "id" },
            }}
            csvFields={[
              "user.firstName",
              "user.lastName",
              "user.id",
              "id",
              "lastUpdated",
            ]}
            globalFilterPlaceholder={"Enter any user or policy id..."}
          />
        </>
      )}
    </>
  );
};

export default PoliciesTable;
